import { MouseEventHandler } from 'react'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Box, IconButton, SxProps } from '@mui/material'
import { grey } from '@mui/material/colors'

import { concatToSXProp } from 'utils/style'

interface CollapseButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>
  collapsed: boolean
  sx?: SxProps
}

const style: SxProps = {
  marginRight: '11px',
  color: grey[500],
}

export default function CollapseButton({
  onClick,
  collapsed,
  sx,
}: CollapseButtonProps): JSX.Element {
  return (
    <Box
      className="append-collapse-button"
      sx={concatToSXProp(sx, {
        background: 'inherit',
        borderRadius: '8px',
      })}
    >
      <IconButton
        onClick={onClick}
        size="small"
        sx={concatToSXProp(style, {
          marginBottom: '8px',
        })}
      >
        {collapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
      </IconButton>
    </Box>
  )
}
